import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import Loading from './components/loading/loading.js'
// ========== 新增：引入axios（用于字体列表请求） ==========
import axios from 'axios';

// ========== 新增：全局字体预加载+缓存逻辑 ==========
/**
 * 功能：预加载常用字体并缓存，避免组件重复请求
 * 缓存策略：7天有效期，过期自动重新请求
 */
async function preloadGlobalFonts() {
  const fontCacheKey = 'preloaded_fonts'; // 缓存键名
  const cachedExpire = localStorage.getItem(`${fontCacheKey}_expire`); // 缓存过期时间
  let fontList = [];

  // 1. 优先使用未过期的缓存
  if (cachedExpire && Date.now() < Number(cachedExpire)) {
    const cachedFonts = localStorage.getItem(fontCacheKey);
    if (cachedFonts) {
      fontList = JSON.parse(cachedFonts);
      return fontList;
    }
  }

  // 2. 缓存过期/无缓存：请求字体接口
  try {
    const res = await axios.get('https://app.yusi.vip/jeecgboot/yusi/scmbController/queryFont');
    if (res.data.code === 200) {
      fontList = res.data.result;
      // 存入localStorage，设置7天有效期
      localStorage.setItem(fontCacheKey, JSON.stringify(fontList));
      localStorage.setItem(`${fontCacheKey}_expire`, Date.now() + 7 * 24 * 60 * 60 * 1000);
    } else {
      fontList = [
        { 
          ztmc: 'Aa厚底黑', 
          url: 'https://www.yusi.vip/DE07BE5D-2F5C-4C23-9479-C83A38503803/file/20240119/504319.ttf?Expires=4889312687&OSSAccessKeyId=LTAI5tSWVUvqJBDWvADw7Ns2&Signature=pUG%2FxYU4pcMo3ZK%2FPXz9y6Wuq6I%3D', 
          sfjc: '是' 
        },
        { ztmc: '微软雅黑', url: '', sfjc: '否' },
        { ztmc: '宋体', url: '', sfjc: '否' }
      ];
    }
  } catch (error) {
    // 降级：使用默认字体列表
    fontList = [
      { 
        ztmc: 'Aa厚底黑', 
        url: 'https://www.yusi.vip/DE07BE5D-2F5C-4C23-9479-C83A38503803/file/20240119/504319.ttf?Expires=4889312687&OSSAccessKeyId=LTAI5tSWVUvqJBDWvADw7Ns2&Signature=pUG%2FxYU4pcMo3ZK%2FPXz9y6Wuq6I%3D', 
        sfjc: '是' 
      },
      { ztmc: '微软雅黑', url: '', sfjc: '否' },
      { ztmc: '宋体', url: '', sfjc: '否' }
    ];
  }

  // 3. 预加载常用字体（仅加载3种核心字体，减少初始加载压力）
  const commonFonts = fontList.filter(font => ['Aa厚底黑', '微软雅黑', '宋体'].includes(font.ztmc));
  const loadPromises = commonFonts.map(font => {
    // 检查字体是否已加载（避免重复创建FontFace）
    if (Array.from(document.fonts).some(f => f.family === font.ztmc)) {
      return Promise.resolve();
    }
    // 无字体URL时使用系统默认字体
    if (!font.url) {
      return Promise.resolve();
    }
    // 创建并加载字体
    const fontFace = new FontFace(font.ztmc, `url("${font.url}")`);
    document.fonts.add(fontFace);
    return fontFace.load().catch(err => {
      console.warn(`⚠️ 字体${font.ztmc}加载失败，将使用系统默认字体`, err);
    });
  });

  // 等待字体加载完成
  await Promise.all(loadPromises);
  console.log('✅ 常用字体预加载完成');
  return fontList;
}

// ========== 修改：初始化App时集成字体预加载 ==========
// 先预加载字体，再挂载App（确保组件渲染时字体已就绪）
async function initApp() {
  // 1. 预加载字体
  const fontList = await preloadGlobalFonts();
  
  // 2. 创建App实例（保持原有配置不变）
  const app = createApp(App)
    .use(ElementPlus, { locale: zhCn })
    .use(store)
    .use(router)
    .use(Loading);

  // 3. 全局注入字体列表，组件可通过 this.$fontList 访问
  app.config.globalProperties.$fontList = fontList;

  // 4. 挂载App
  app.mount('#app');
}

// 启动App初始化
initApp();